import { Component, Inject, Injector } from "@angular/core";
import { AUC_ICONS_CONFIG_TOKEN, AUC_LINKS_CONFIG_TOKEN, AucIconsConfig, AucLinksConfig } from "@auction-ui/config";
import { MfBaseComponent, mfDateCurrent, MfTypeInfo } from "@pattonair/material-framework";

const TYPE_INFO: MfTypeInfo = { className: "AucFooterComponent" };

@Component({
  selector: "ecom-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class AucFooterComponent extends MfBaseComponent {
  protected _mfDateCurrent = mfDateCurrent;

  public constructor(
    protected override _injector: Injector,
    @Inject(AUC_ICONS_CONFIG_TOKEN)
    protected _iconsConfig: AucIconsConfig,
    @Inject(AUC_LINKS_CONFIG_TOKEN)
    protected _linksConfig: AucLinksConfig,
  ) {
    super(TYPE_INFO, _injector);
  }
}